import { Link } from "react-router-dom";

export const ProductCard = ({ product, large = false }) => (
  <article
    data-testid={`product-card-${product.id}`}
    className="group bg-white rounded-xl border border-[#e2ded4] overflow-hidden flex flex-col hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 h-full"
  >
    <div className={`${large ? "h-60" : "h-48"} bg-[#f4f1ea] overflow-hidden`}>
      <img
        src={product.image}
        alt={product.alt}
        loading="lazy"
        className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
      />
    </div>
    <div className="p-5 flex flex-col flex-1">
      <h3 className="font-heading text-lg font-bold text-[#0d1f18]">{product.name}</h3>
      {product.supplementary && (
        <p className="mt-1 text-[11px] text-[#5a6b5c] italic">
          Representative image — our product photo coming soon
        </p>
      )}
      <p className="mt-2 text-sm text-[#5a6b5c] leading-relaxed">{product.desc}</p>
      {product.uses && (
        <p className="mt-2 text-xs text-[#2d6a4f] font-medium">{product.uses}</p>
      )}
      <Link
        to={`/contact?product=${encodeURIComponent(product.name)}`}
        data-testid={`product-cta-${product.id}`}
        className="mt-4 inline-flex justify-center items-center text-sm font-semibold text-[#1b4332] border border-[#1b4332]/30 rounded-lg px-4 py-2.5 hover:bg-[#1b4332] hover:text-white transition-colors mt-auto"
      >
        Request Bulk Pricing
      </Link>
    </div>
  </article>
);
